import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnsubscribeService extends Subject<void> implements OnDestroy {
  public ngOnDestroy() {
    this.next();
    this.complete();
  }
}
